// import axios from "axios";
//
// // Déterminez si un token existe dans le localStorage
// let token = '';
// if (localStorage.getItem("userAuth")) {
//   const userAuth = JSON.parse(localStorage.getItem("userAuth"));
//   token = userAuth.user.api_token;
// }
//
// // Définissez une variable globale warning_message initialisée à une chaîne vide
// let warning_message = ""; // Utilisation de let à la place de var
//
// // Créez votre instance personnalisée d'Axios
// const axiosInstance = axios.create({
//   withCredentials: false,
//  baseURL: `http://192.168.5.111:8000/api`,
//   //baseURL: `http://192.168.5.111:8000/api/`,
//   headers: {
//     Authorization: `Bearer ${token}`,
//     apipassword: "sKgkGkRhObr0kXdrNyjW5S",
//   },
// });
//
// // Définissez l'intercepteur de réponse sur votre instance personnalisée
// /*axiosInstance.interceptors.response.use(
//   response => {
//
//     console.log("ALL_RESPONSES", response);
//     // Mettez à jour la variable warning_message uniquement en cas de succès de la réponse
//
//       warning_message = "OKK";
//     console.log("wm",warning_message)
//     return response;
//   },
//   error => {
//     // En cas d'erreur, vous pouvez également mettre à jour la variable warning_message ici si nécessaire
//     return Promise.reject(error);
//   }
// );*/
//
// export default axiosInstance;
// //export { warning_message };
import axios from "axios";

const api = axios.create({
    withCredentials: true,
    baseURL: "http://192.168.5.111:8000/api",
});

api.interceptors.request.use((config) => {

    const userAuth = localStorage.getItem("userAuth");

    if (userAuth) {

        const token = JSON.parse(userAuth).user.api_token;

        config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.apipassword = "sKgkGkRhObr0kXdrNyjW5S";

    return config;
});

export default api;